import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const BREAKPOINTS = {
  TABLET : 767,
  DESKTOP : 960
}

export class ReactAccordion extends Component {
  static init (accordion, index) {
    if (ReactDOM.findDOMNode(accordion)) {
      ReactDOM.unmountComponentAtNode(accordion);
    }

    let title = accordion.querySelector('[data-accordion-title]');
    let content = accordion.querySelector('[data-accordion-content]');
    let config = accordion.dataset;

    ReactDOM.render(
      <ReactAccordion key={index} title={title} content={content} config={config} />,
      accordion
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen : this.setIsOpen(),
      isTabbing : false
    }

    this.handleFirstTab = this.handleFirstTab.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleFirstTab);
  }

  setIsOpen() {
    const { config } = this.props;

    let winWidth = window.innerWidth;

    if(config) {
      let defaultOpen = config.accordionDefaultExpanded !== undefined ? true : false
      let openMobile = config.accordionMobileExpanded !== undefined ? true : false
      let openTablet = config.accordionTabletExpanded !== undefined ? true : false
      let openDesktop = config.accordionDesktopExpanded !== undefined ? true : false

      if( defaultOpen ) return true
      if( winWidth > BREAKPOINTS.DESKTOP && openDesktop ) return true;
      if( winWidth > BREAKPOINTS.TABLET && openTablet ) return true;
      if( openMobile ) return true;
    }
    return false;
  }

  handleFirstTab(e) {
    if (e.keyCode === 9) { // the "I am a tabbing/keyboard user" key
      this.setState({
        isTabbing: true
      }, () => {
        window.removeEventListener('keydown', this.handleFirstTab);
      })
    }
  }

  createMarkup(content) {
    return { __html: content.innerHTML }
  }

  toggleAccordion(e) {
    e.preventDefault();
    this.setState({
      isOpen : this.state.isOpen ? false : true,
    })
  }

  buildClassList(classList) { // Function required to build out classes in IE11!
    let classes = [];

    for(let i=0; i < classList.length; i++) {
      classes.push( classList[i] );
    }
    return classes.join(' ');
  }

  render() {
    const { title, content } = this.props;
    const wrapperClasses = this.state.isTabbing ? 'accordion-js-enabled accordion-user-tabbing' : 'accordion-js-enabled'
    const styles = {
      closed : {
        height: 0,
        overflow: "hidden",
        marginBottom: 0,
        paddingTop: 0
      },
      open : {},
      plusIcon : {
        transform : this.state.isOpen ? "rotateZ(45deg)" : "rotateZ(0)",
        transition : "0.2s ease-in-out"
      }
    }

    if(title.id) {
      const toggleId = `.${title.id}--toggle`;
      const toggle = document.querySelector(toggleId);
      if(toggle) {
        toggle.style.visibility = this.state.isOpen ? 'hidden' : 'visible';
      }
    }

    return (
      <div className={wrapperClasses}>
        <h2
          className={this.buildClassList(title.classList)}
          id={title.id}>
          <button
            type="button"
            onClick={(e) => this.toggleAccordion(e)}
            className="accordion-control accordion-control--heading">
            <span dangerouslySetInnerHTML={{__html: `${title.innerHTML}`}}/>
          </button>
          <span
            style={styles.plusIcon}
            className="accordion-control-icon"
          />
        </h2>
        <div
          className={this.state.isOpen ?
            this.buildClassList(content.classList) :
            this.buildClassList([...content.classList, 'u-hidden'])
          }
          dangerouslySetInnerHTML={this.createMarkup(content)}
          style={this.state.isOpen ? styles.open : styles.closed}
        />
      </div>
    )
  }
}
